'use strict';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var SqlString = require('sqlstring');
var debug = require('debug')('leoric');
var parseExpr = require('../../expr').parseExpr;
var heresql = require('../../utils/string').heresql;
exports.escape = function escape(value) {
    if (typeof value === 'boolean')
        return +value;
    return SqlString.escape(value);
};
exports.escapeId = function escapeId(identifier) {
    return "\"".concat(identifier.replace(/"/g, '""'), "\"");
};
/**
 * Schema altering commands other than RENAME COLUMN or ADD COLUMN
 * - https://www.sqlite.org/lang_altertable.html
 * @param {string} table
 * @param {Object} attributes the changed attributes
 */
exports.alterTableWithChangeColumn = function alterTableWithChangeColumn(driver, table, changes) {
    return __awaiter(this, void 0, void 0, function () {
        var escapeId, schemaInfo, columns, changeMap, newAttributes, columns_1, columns_1_1, column, columnName, change, changes_1, changes_1_1, attribute, newColumns, newAttributes_1, newAttributes_1_1, attribute, columnName, defaultValue, change, connection, newTable, err_1;
        var e_1, _a, e_2, _b, e_3, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    escapeId = driver.escapeId;
                    return [4 /*yield*/, driver.querySchemaInfo(null, table)];
                case 1:
                    schemaInfo = _d.sent();
                    columns = schemaInfo[table];
                    changeMap = changes.reduce(function (result, entry) {
                        result[entry.columnName] = entry;
                        return result;
                    }, {});
                    newAttributes = [];
                    try {
                        for (columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
                            column = columns_1_1.value;
                            columnName = column.columnName;
                            change = changeMap[columnName];
                            if (!change || !change.remove) {
                                newAttributes.push(Object.assign(column, change));
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    try {
                        for (changes_1 = __values(changes), changes_1_1 = changes_1.next(); !changes_1_1.done; changes_1_1 = changes_1.next()) {
                            attribute = changes_1_1.value;
                            if (!attribute.modify && !attribute.remove) {
                                newAttributes.push(attribute);
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (changes_1_1 && !changes_1_1.done && (_b = changes_1.return)) _b.call(changes_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    newColumns = [];
                    try {
                        for (newAttributes_1 = __values(newAttributes), newAttributes_1_1 = newAttributes_1.next(); !newAttributes_1_1.done; newAttributes_1_1 = newAttributes_1.next()) {
                            attribute = newAttributes_1_1.value;
                            columnName = attribute.columnName, defaultValue = attribute.defaultValue;
                            change = changeMap[columnName];
                            if (!change || change.modify) {
                                newColumns.push(escapeId(columnName));
                            }
                            else {
                                newColumns.push(SqlString.escape(defaultValue));
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (newAttributes_1_1 && !newAttributes_1_1.done && (_c = newAttributes_1.return)) _c.call(newAttributes_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return [4 /*yield*/, driver.getConnection()];
                case 2:
                    connection = _d.sent();
                    return [4 /*yield*/, connection.query('BEGIN')];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, 10, 12, 14]);
                    newTable = "new_".concat(table);
                    return [4 /*yield*/, driver.createTable(newTable, newAttributes, { connection: connection })];
                case 5:
                    _d.sent();
                    return [4 /*yield*/, connection.query(heresql("\n      INSERT INTO ".concat(escapeId(newTable), "\n      SELECT ").concat(newColumns.join(', '), "\n      FROM ").concat(escapeId(table), "\n    ")))];
                case 6:
                    _d.sent();
                    return [4 /*yield*/, connection.query("DROP TABLE ".concat(escapeId(table)))];
                case 7:
                    _d.sent();
                    return [4 /*yield*/, connection.query(heresql("\n      ALTER TABLE ".concat(escapeId(newTable), "\n      RENAME TO ").concat(escapeId(table), "\n    ")))];
                case 8:
                    _d.sent();
                    return [4 /*yield*/, connection.query('COMMIT')];
                case 9:
                    _d.sent();
                    return [3 /*break*/, 14];
                case 10:
                    err_1 = _d.sent();
                    return [4 /*yield*/, connection.query('ROLLBACK')];
                case 11:
                    _d.sent();
                    throw err_1;
                case 12: return [4 /*yield*/, connection.release()];
                case 13:
                    _d.sent();
                    return [7 /*endfinally*/];
                case 14: return [2 /*return*/];
            }
        });
    });
};
// eslint-disable-next-line no-unused-vars
exports.parseDefaultValue = function parseDefaultValue(text, type) {
    if (typeof text !== 'string')
        return text;
    if (type === 'boolean')
        return text === 'true';
    try {
        var ast = parseExpr(text);
        if (ast.type === 'literal') {
            return ast.value;
        }
    }
    catch (err) {
        debug('[parseDefaultValue] [%s] %s', text, err);
    }
    return text;
};
//# sourceMappingURL=sqlstring.js.map